import axios, { AxiosRequestConfig, AxiosError } from "axios";
import { BaseQueryFn } from '@reduxjs/toolkit/query';

const getConfig = (): AxiosRequestConfig => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
    },
    data: {},
  };
};

const axiosBaseQuery = (): BaseQueryFn<
  { url: string; method: AxiosRequestConfig['method']; data?: any },
  unknown,
  unknown
> => async ({ url, method, data }) => {
  try {
    const options = getConfig();
    if(method === "POST"){
        const res = await axios.post(process.env.REACT_APP_BACKEND_API_URL + url, data, options);
        return { data: res.data };
    }
    if(method === "GET"){
        const res = await axios.get(process.env.REACT_APP_BACKEND_API_URL + url, options)
        return {data: res.data};
    }
    if (method === 'PUT') {
      const res = await axios.put(process.env.REACT_APP_BACKEND_API_URL + url, data, options);
      return { data: res.data };
    }
    return {};
  } catch (axiosError) {
    let err = axiosError as AxiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export default axiosBaseQuery;
